import axios from 'axios';
import api from '@/common/api';

let extimate = (btn, callback) => {
  const params = {
    param: {
      buttonCodes: btn.join()
    }
  }
  axios.post(api.getBtnAuth, params).then((res) => {
    if(res.errorCode==0 && res.objectResult){
      callback(res.objectResult)
    }
  })
}
const btn_extimate = (btn, callback) => {
  return extimate(btn, callback)
}

const BTN = {
  //工作台按钮权限
  HOME_reviewNewCorporate:'b100_000101_000',
  HOME_reviewOldCorporate:'b100_000101_001',
  HOME_reviewCar:'b100_000101_002',
  HOME_reviewSignDeposit:'b100_000101_003',
  HOME_reviewUncheckDriver:'b100_000101_004',
  HOME_showData:'b100_000101_005',

  COMPANY_DETAIL: "b100_000301_000",
  COMPANY_PASS: "b100_000301_001",
  COMPANY_REFUSE: "b100_000301_002",
  COMPANY_UPDATE: "b100_000301_003",

  CAR_DETAIL: "b100_000303_000",
  CAR_DELETE: "b100_000303_001",
  CAR_PASS: "b100_000303_002",
  CAR_REFUSE: "b100_000303_003",
  CAR_EDITPUB: "b100_000303_004",
  DRIVER_DETAIL: "b100_000304_000",
  DRIVER_BLACK: "b100_000304_001",
  DRIVER_EDITPUB: "b100_000304_002",
  DRIVER_FACE_RECOGNITION: "b100_000304_003",
  DRIVER_DELETE: "b100_000304_004",

  WAYBILLPAY_REFUND:"m100_0099_001",
  BILL_DETAIL: "b100_000501_000",
  BILL_CLOSE: "b100_000501_001",
  BILLTASK_DETAIL: "b100_000502_000",
  BILLTASK_CLOSE: "b100_000502_001",
  BIGORDER_DETAIL:"b100_0006_000",
  BIGORDER_DELETE:"b100_0006_001",
  SOURCE_DETAIL:"b100_0007_000",
  SOURCE_REMOVE:"b100_0007_001",
  CARSOURCE_DETAIL:"b100_0009_001",
  CARSOURCE_REMOVE:"b100_0009_002",
  SETTLE_DETAIL:"b100_0010_000",
  DEPOSIT_DEDUCT:"b100_0011_000",
  BLACK_ADD: "b100_0012_000",
  BLACK_DELETE: "b100_0012_001",

  STUDY_DELETESTORE: "b100_0013_000",
  STUDY_ADDSTORE: "b100_0013_001",
  STUDY_PUBLISH: "b100_0013_002",
  STUDY_DELETE: "b100_0013_003",
  STUDY_UPDATE: "b100_0013_004",
  STUDY_ADDTEST: "b100_0013_006",
  STUDY_UPDATETEST: "b100_0013_007",
  STUDY_DELETETEST: "b100_0013_008",
  STUDY_UPDATEMATERIAL: "b100_0013_009",

  COMPANY_FACE_RECOGNITION: "b100_001302_000",

  NEWS_DELETECOLUMN:"b100_001401_000",
  NEWS_ADDCOLUMN:"b100_001401_001",
  NEWS_UPDATECOLUMN:"b100_001401_010",
  NEWS_ADDARTICLE:"b100_001401_011",
  NEWS_UPDATEARTICLE:"b100_001401_100",
  NEWS_DELETEARTICLE:"b100_001401_101",
  ADS_ADD:"b100_001402_000",
  ADS_DELETE:"b100_001402_001",
  ADS_UPDATE:"b100_001402_010",

  USER_ADD: "b100_001501_000",
  USER_UPDATE: "b100_001501_001",
  USER_DELETE: "b100_001501_002",
  ROLE_ADD: "b100_001502_000",
  ROLE_UPDATE: "b100_001502_001",
  ROLE_DELETE: "b100_001502_002",
  MENU_ADDSAME: "b100_001503_000",
  MENU_UPDATE: "b100_001503_001",
  MENU_ADDTOP: "b100_001503_002",
  MENU_ADDCHILD: "b100_001503_004",
  MENU_DELETE: "b100_001503_005",

  BTN_ADD: "b100_001504_000",
  BTN_UPDATE: "b100_001504_001",
  BTN_DELETE: "b100_001504_002",
  CONFIG_ADD: "b100_001505_000",
  CONFIG_UPDATE: "b100_001505_001",
  JOBMANAGE_ADD: "b100_001506_000",
  JOBMANAGE_STOP: "b100_001506_001",
  JOBMANAGE_RECOVER: "b100_001506_002",
  JOBMANAGE_RESTART: "b100_001506_003",
  JOBMANAGE_UPDATE: "b100_001506_004",
  JOBMANAGE_DELETE: "b100_001506_005",
  CACHE_DELETECODE: "b100_001507_000",
  CACHE_DELETECONFIG: "b100_001507_001",

  MSGPATTERN_ADD: "b100_001508_000",
  MSGPATTERN_UPDATE: "b100_001508_001",
  MSGPATTERN_DELETE: "b100_001508_002",
  MSGRULE_STOP: "b100_001509_000",
  MSGRULE_UPDATE: "b100_001509_001",
  MSGRULE_DELETE: "b100_001509_002",
  MSGRULE_ADD: "b100_001509_003",
  MSGRULE_START: "b100_001509_004",
  MSG_CURRENTREAD: "b100_001510_000",
  MSG_ALLREAD: "b100_001510_001",
  MSG_SEND: "b100_001511_000",
  FEEDBACK_CHECK: "b100_0016_000",

  TRAILER_DETAIL: "b100_0017_000",
  TRAILER_EDIT: "b100_0017_001",
  TRAILER_DELETE: "b100_0017_002",
  TRAILER_AUDIT_DETAIL: "b100_0017_003",
  TRAILER_AUDIT_PASS: "b100_0017_004",
  TRAILER_AUDIT_REJECT: "b100_0017_005",

  CHECKLIST_EXPORTDATA: "b100_0024_001",
  CHECKLIST_DELETEINFO: "b100_0024_002",

  ISP_DETAIL: "b100_000307_000",//罐检管理-详情
  ISP_EDITPUB: "b100_000307_001",//罐检管理-更正
  ISP_DELETE: "b100_000307_002",//罐检管理-删除
  ISP_AUDIT_DETAIL: "b100_000307_003",//罐检管理-审核详情
  ISP_AUDIT_PASS: "b100_000307_004",//罐检管理-审核通过
  ISP_AUDIT_REJECT: "b100_000307_005",//罐检管理-审核拒绝
}

export {
  btn_extimate,
  BTN
}



// WEBPACK FOOTER //
// ./src/utils/btnAuth.js